import * as React from "react";
import image from "./assets/noAccess.jpg"

export const NoAccess: React.FC = props => {
    return <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
        <h1>You have no access to this page</h1>
        <img src={image} />
        <p>But nice try!</p>
    </div>
}